<template>
    <circle xmlns="http://www.w3.org/2000/svg" cx="20.3653" cy="6.62313" r="6.62313"/>
    <path d="M0.726562 6.73348L10.5509 0.110352L10.6613 16.5578H17.174L10.6613 23.1809V29.8041L0.726562 39.6284V6.73348Z" />
</template>
